module.exports = __webpack_public_path__ + "assets/images/team/Olia.jpg";